import { CommonModule, NgIf } from '@angular/common';
import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { FormStorageService } from '../../services/form-storage.service';
import { UploadBillModalComponent } from '../../components/bill/upload-bill-modal/upload-bill-modal.component';
import { FilterBillModalComponent } from '../../components/bill/filter-bill-modal/filter-bill-modal.component';

interface Bill {
  xmlName: string;
  pdfName: string;
  status: string;
  payDate: string;
}

@Component({
  selector: 'app-bill-page',
  imports: [NgIf, CommonModule, FormsModule, UploadBillModalComponent, FilterBillModalComponent],
  templateUrl: './bill-page.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})

export class BillPageComponent implements OnInit {
  bills: Bill[] = [];
  showModal = false;
  showFilterModal = false;

  filterText = '';
  filterStartDate: Date | null = null;
  filterEndDate: Date | null = null;
  filterStatus = '';

  private readonly STORAGE_KEY = 'billDocs';

  constructor(private formStorage: FormStorageService) {}

  ngOnInit(): void {
    const savedBills = this.formStorage.load<Bill[]>(this.STORAGE_KEY);
    if (savedBills) {
      this.bills = savedBills;
    }
  }

  openModal() {
    this.showModal = true;
  }

  closeModal() {
    this.showModal = false;
  }

  handleFilesUpload(event: { pdf: File; xml: File }) {
    const randomStatuses = ['Pendiente'];
    const randomStatus = randomStatuses[Math.floor(Math.random() * randomStatuses.length)];
    const currentDate = new Date().toLocaleDateString('es-ES', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
    });

    const newBill = {
      pdfName: event.pdf.name,
      xmlName: event.xml.name,
      status: randomStatus,
      payDate: currentDate,
    };

    this.bills.push(newBill);
    this.formStorage.save(this.STORAGE_KEY, this.bills);

    this.closeModal();
  }

  onApplyFilters(filters: {
    text: string;
    startDate: Date | null;
    endDate: Date | null;
    status: string;
  }){
    this.filterText = filters.text;
    this.filterStartDate = filters.startDate;
    this.filterEndDate = filters.endDate;
    this.filterStatus = filters.status;
  }

  get filteredBills() { 
    return this.bills.filter((bill) => {
      const matchesText = 
        this.filterText === '' || 
        bill.pdfName.toLowerCase().includes(this.filterText.toLowerCase()) ||
        bill.xmlName.toLowerCase().includes(this.filterText.toLowerCase());
      
      const uploadDate = new Date(bill.payDate.split('/').reverse().join('-'));

      const startDate = this.filterStartDate;
      const endDate = this.filterEndDate;
      const matchesDate = (!startDate || uploadDate >= startDate) && (!endDate || uploadDate <= endDate);
      
      const matchesStatus = this.filterStatus === '' || bill.status === this.filterStatus;

      return matchesText && matchesDate && matchesStatus;
    })
  }

  hasActiveFilters(): boolean {
    return (this.filterText !== '' || this.filterStatus !== '' || this.filterStartDate !== null || this.filterEndDate !== null);
  }

  clearAllFilters(): void {
    this.filterText = '';
    this.filterStatus = '';
    this.filterStartDate = null;
    this.filterEndDate = null;
  }
}
